import MuiAccordion, { AccordionProps } from '@mui/material/Accordion';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import MuiAccordionSummary, { AccordionSummaryProps } from '@mui/material/AccordionSummary';
import { styled } from '@mui/material/styles';
import React from 'react';

import { Stack, Typography } from '@mui/material';
import StepIconActive from '../resources/images/accordion_step_active.svg';
import StepIconInActive from '../resources/images/accordion_step_inactive.svg';
import './Accordion.scss';

interface ExtendedAccordionSummaryProps extends AccordionSummaryProps {
    expandIconActive?: React.ReactNode;
    expandIconInActive?: React.ReactNode;
    expanded: boolean;
    title?: string;
    thisStep?: number;
    totalSteps?: number;
    stepTitle?: string;
    dataTestIdTitle?: string;
    dataTestIdStep?: string;
}

const Accordion = styled((props: AccordionProps) => <MuiAccordion disableGutters elevation={0} square {...props} />)(
    ({ theme }) => ({
        borderBottom: `1px solid ${theme.palette.divider}`,
        '&:before': {
            display: 'none',
        },
        marginBottom: 20,
    }),
);

const AccordionSummary = styled((props: ExtendedAccordionSummaryProps) => {
    const {
        stepTitle,
        expanded,
        expandIconActive,
        expandIconInActive,
        title,
        children,
        thisStep,
        totalSteps,
        dataTestIdTitle,
        dataTestIdStep,
    } = props;

    let className = '';
    if (expanded) {
        className = `${className} AccordionSummaryActiveTitle`;
    } else {
        className = `${className} AccordionSummaryInActiveTitle`;
    }

    const st = stepTitle ? stepTitle : 'Default Step Title';

    return (
        <MuiAccordionSummary
            expandIcon={
                expanded ? (
                    expandIconActive ? (
                        expandIconActive
                    ) : (
                        <img alt="" src={StepIconActive} />
                    )
                ) : expandIconInActive ? (
                    expandIconInActive
                ) : (
                    <img alt="" src={StepIconInActive} />
                )
            }
            {...props}
        >
            <Stack className="AccordianSummaryRoot" direction="row" justifyContent="space-between" alignItems="center">
                <Stack direction="row" alignItems="center">
                    <Typography classes={{ root: className }} data-testid={dataTestIdTitle}>
                        {title}
                    </Typography>
                    <div>{children}</div>
                </Stack>
                <Stack data-testid={dataTestIdStep} direction="row">
                    <Typography className="AccordianSummaryStepSummary1">
                        {st}&nbsp;{thisStep || 0}
                    </Typography>
                    <Typography className="AccordianSummaryStepSummary2">&nbsp;{`/ ${totalSteps || 0}`}</Typography>
                </Stack>
            </Stack>
        </MuiAccordionSummary>
    );
})(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, .05)' : 'rgba(0, 0, 0, 0)',
    flexDirection: 'row-reverse',
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
        transform: 'rotate(0deg)',
    },
    '& .MuiAccordionSummary-content': {
        marginLeft: theme.spacing(1),
    },
    height: '90px',
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(4),
    borderTop: '1px solid rgba(0, 0, 0, .125)',
}));

export { Accordion, AccordionDetails, AccordionSummary };
